// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* our variables */\ntbody tr:hover {\n  background-color: transparent !important;\n}\n.seuil-text {\n  font-size: 10px;\n  margin-left: 25px;\n  /* Adds space between the date and the span */\n}", ""]);
// Exports
module.exports = exports;
